import React, { useState } from "react";
import {
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Slider,
  Typography,
  Box,
} from "@mui/material";

function AutopickSettings() {
  const [selectedAlgorithm, setSelectedAlgorithm] = useState<string | null>(
    "Standard"
  );
  const [maxBudget, setMaxBudget] = useState<number>(40);

  const handleAlgorithmChange = (
    _event: React.MouseEvent<HTMLElement>,
    newAlgorithm: string | null
  ) => {
    if (newAlgorithm !== null) {
      setSelectedAlgorithm(newAlgorithm);
    }
  };

  const handleBudgetChange = (_event: Event, newValue: number | number[]) => {
    setMaxBudget(newValue as number);
  };

  return (
    <>
      <ToggleButtonGroup
        value={selectedAlgorithm}
        exclusive
        onChange={handleAlgorithmChange}
        aria-label="autopick algorithm"
      >
        <Tooltip title="This is a default autopick method">
          <ToggleButton value="Standard" aria-label="standard">
            Standard
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Prioritizes the best price">
          <ToggleButton value="Deal Hunter" aria-label="deal hunter">
            Deal Hunter
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Prioritizes choosing the best talent available +$10 per event">
          <ToggleButton value="Premium" aria-label="premium">
            Premium
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>

      <Typography gutterBottom>Max Hourly Budget: ${maxBudget}</Typography>
      <Box width="25%">
        <Slider
          value={maxBudget}
          onChange={handleBudgetChange}
          aria-labelledby="max-budget-slider"
          valueLabelDisplay="auto"
          step={5}
          marks
          min={50}
          max={80}
        />
      </Box>
    </>
  );
}

export default AutopickSettings;
